module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/header-text@3x-149c9fd7ceb4f7288004fe92b05b56d9.png";